<template>
  <div>
    <h5 class="shipping-contact">
      <b-button v-if="withEdit && isEditable" variant="link" size="sm" class="p-0" style="font-size: .9em" v-b-modal="'modalEdit_' + checkpoint + '_' + shipping.id" @click="shippingEdit = shipping"><font-awesome-icon icon="edit" style="vertical-align: baseline" /></b-button>
      {{shipping[checkpoint + '_contact']}}
    </h5>
    <div>
      <span v-if="(!shipping.fields_revision || shipping.fields_revision === false) || (shipping.fields_revision && shipping.fields_revision === true) || !shipping.fields_revision_data?.[checkpoint] || typeof shipping.fields_revision_data?.[checkpoint] === 'object'" class="shipping-address"
      >
        <div v-if="ecosystemModules?.geofences && shipping.meta?.geofences?.[checkpoint]?.external_id" :title="`${$options.filters.cleanentityprefix(shipping.meta.geofences[checkpoint].name)} (${shipping.meta.geofences[checkpoint].reference_location})`" v-b-tooltip.hover>
          <p class="mb-1 shipping-address">
            <strong>
              {{shipping.meta.geofences[checkpoint].name | cleanentityprefix}} ({{shipping.meta.geofences[checkpoint].reference_location}})
            </strong>
            <br>
            {{shipping.meta.geofences[checkpoint].external_id | cleanentityprefix}}
          </p>
        </div>
        <span
          class="shipping-address"
          :class="shipping.fields_revision_data &&
            shipping.fields_revision_data[checkpoint] &&
            typeof shipping.fields_revision_data[checkpoint] === 'object' ? 'text-warning' : ''"
          :title="shipping['address_' + checkpoint].formatted_address"
          v-if="shipping['address_' + checkpoint]"
          v-b-tooltip.hover>
          <font-awesome-icon v-if="shipping.fields_revision_data &&
            shipping.fields_revision_data[checkpoint] &&
            typeof shipping.fields_revision_data[checkpoint] === 'object'" icon="exclamation-triangle" size="1x" />
          <b-button size="sm" @click.stop="openMapOn(shipping['address_' + checkpoint].formatted_address + '/@' + shipping['address_' + checkpoint].lat + ',' + shipping['address_' + checkpoint].lng + ',17z')" class="py-0 px-1" :title="$gettext('Quick view address map on new window')">
            <font-awesome-icon :icon="['fa', 'map-marked-alt']" size="2x" style="font-size: 10px; vertical-align: middle;" />
          </b-button>
          {{shipping['address_' + checkpoint].formatted_address}}
        </span>
      </span>
      <span v-if="typeof shipping.fields_revision_data?.[checkpoint] === 'string'">
        <span
          class="shipping-address text-danger"
          :title="shipping.fields_revision_data[checkpoint]"
          v-b-tooltip.hover>
          <font-awesome-icon icon="exclamation-triangle" size="1x" /> {{shipping.fields_revision_data[checkpoint]}}
        </span>
      </span>
      <div v-if="!withIcons">
        <div v-translate="{extra: shipping[checkpoint + '_extra'] || '-'}">
          Floor, door, etc.: <strong>%{extra}</strong>
        </div>
        <div v-if="checkpoint !== 'from' || shipping.company" v-translate="{email: shipping[checkpoint + '_email'] || '-'}">
          Email: <strong>%{email}</strong>
        </div>
        <div v-if="checkpoint !== 'from' || shipping.company" v-translate="{phone: shipping[checkpoint + '_phone'] ? $options.filters.phone(shipping[checkpoint + '_phone']) : '-'}">
          Phone: <strong>%{phone}</strong>
        </div>
      </div>
      <div v-else>
        <div v-if="shipping[checkpoint + '_extra'] && shipping[checkpoint + '_extra'] !== ' '">
          <font-awesome-icon size="1x" icon="crosshairs" color="dark" />
          {{shipping[checkpoint + '_extra']}}
        </div>
        <div v-if="shipping[checkpoint + '_email']">
          <font-awesome-icon size="1x" icon="envelope" color="dark" />
          {{shipping[checkpoint + '_email']}}
        </div>
        <div v-if="shipping[checkpoint + '_phone'] && shipping[checkpoint + '_phone'] !== ' '">
          <font-awesome-icon size="1x" icon="phone" color="dark" />
          {{shipping[checkpoint + '_phone'] | phone}}
        </div>
      </div>
      <div v-if="withExtraCheckpoints && (checkpoint === 'from' && shipping.meta && shipping.meta.extraCheckpoints && shipping.meta.extraCheckpoints.beforePickup && shipping.meta.extraCheckpoints.beforePickup.length > 0) || (checkpoint === 'to' && shipping.meta && shipping.meta.extraCheckpoints && shipping.meta.extraCheckpoints.beforeDelivery && shipping.meta.extraCheckpoints.beforeDelivery.length > 0)">
        <hr class="my-1">
        <h6 :id="'tooltip-extra-checkpoints-' + checkpoint + shipping.id">
          <translate>Place Extra Data</translate>
          <span v-if="shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'].filter(x => x.dupe).length > 0">
            <font-awesome-icon icon="exclamation-triangle" class="text-warning" />
          </span>
        </h6>
        <b-tooltip :target="'tooltip-extra-checkpoints-' + checkpoint + shipping.id" triggers="hover" custom-class="tooltip-w350" v-if="withTooltip">
          <p v-if="shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place" class="m-0">
            <b-button size="sm" @click.stop="openMapOn(shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place.formatted_address + '/@' + shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place.lat + ',' + shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place.lng + ',17z')" class="py-0 px-1" :title="$gettext('Quick view address map on new window')">
              <font-awesome-icon :icon="['fa', 'map-marked-alt']" size="2x" style="font-size: 10px; vertical-align: middle;" />
            </b-button>
            {{shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place.formatted_address}}
            <small class="text-nowrap">
              <em>
                ({{shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place.lat}}, {{shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place.lng}})
              </em>
            </small>
          </p>
          <b-list-group v-if="shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].geo_type_id">
            <b-list-group-item class="p-1 text-left bg-dark" v-for="(element, index) in shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery']" :key="(checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery') + index">
              <span v-if="element.dupe">
                <font-awesome-icon icon="exclamation-triangle" class="text-warning" />
              </span>
              <strong>{{element.external_id | cleanentityprefix}}</strong> {{ element.name | cleanentityprefix }} <small>[{{ element.geo_type ? element.geo_type.name : geoTypes.find(x => x.id === element.geo_type_id).name }}]</small>
            </b-list-group-item>
          </b-list-group>
        </b-tooltip>
        <div v-else>
          <p v-if="shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place">
            <b-button size="sm" @click.stop="openMapOn(shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place.formatted_address + '/@' + shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place.lat + ',' + shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place.lng + ',17z')" class="py-0 px-1" :title="$gettext('Quick view address map on new window')">
              <font-awesome-icon :icon="['fa', 'map-marked-alt']" size="2x" style="font-size: 10px; vertical-align: middle;" />
            </b-button>
            {{shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place.formatted_address}}
            <small class="text-dnowrap">
              <em>
                ({{shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place.lat}}, {{shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].place.lng}})
              </em>
            </small>
          </p>
          <b-list-group v-if="shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery'][0].geo_type_id">
            <b-list-group-item class="p-2" v-for="(element, index) in shipping.meta.extraCheckpoints[checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery']" :key="(checkpoint === 'from' ? 'beforePickup' : 'beforeDelivery') + index">
              <span v-if="element.dupe">
                <font-awesome-icon icon="exclamation-triangle" class="text-warning" />
              </span>
              <strong>{{element.external_id | cleanentityprefix}}</strong> {{ element.name | cleanentityprefix }} <small>[{{ element.geo_type ? element.geo_type.name : geoTypes.find(x => x.id === element.geo_type_id).name }}]</small>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
      <div v-if="withInstructions">
        <hr>
        <h6 v-translate>Instructions</h6>
        <div v-html="$options.filters.brize(shipping[checkpoint + '_meta'] || '-')" style="height: auto; max-height: 90px; overflow-y: scroll;"></div>
      </div>
    </div>
    <b-modal size="lg" :id="'modalEdit_' + checkpoint + '_' + shipping.id" :ref="'modalEdit_' + checkpoint + '_' + shipping.id" hide-footer @hide="shippingEdit = {}">
      <template #modal-title>
        <translate v-if="checkpoint === 'from'">Edit Origin Information</translate>
        <translate v-if="checkpoint === 'to'">Edit Destination Information</translate>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <shipping-checkpoint-form :checkpoint="checkpoint" :shipping="shippingEdit" @success="emitUpdated(); $refs['modalEdit_' + checkpoint + '_' + shipping.id].hide();" @cancel="$refs['modalEdit_' + checkpoint + '_' + shipping.id].hide();" />
    </b-modal>
  </div>
</template>

<script>
import ShippingCheckpointForm from '@/components/Shippings/CheckpointForm'

export default {
  emits: ['updated'],
  name: 'ShippingCheckpoint',
  components: {
    ShippingCheckpointForm
  },
  props: {
    shipping: {
      type: Object,
      required: true
    },
    checkpoint: {
      type: String,
      default: 'to'
    },
    withInstructions: {
      type: Boolean,
      default: false
    },
    withEdit: {
      type: Boolean,
      default: false
    },
    withIcons: {
      type: Boolean,
      default: false
    },
    withExtraCheckpoints: {
      type: Boolean,
      default: false
    },
    withTooltip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shippingEdit: {}
    }
  },
  computed: {
    isEditable() {
      return this.shipping.company &&
        this.shipping.status !== 'DELIVERED' &&
        this.shipping.status !== 'CANCELED' &&
        this.shipping.status !== 'RETURNED'
    }
  },
  methods: {
    emitUpdated() {
      this.$emit('updated', true)
    }
  }
}
</script>

<style lang="scss">
.tooltip-w350 {
  .tooltip-inner {
    max-width: 350px !important;

  }
}
</style>
